// extracted by mini-css-extract-plugin
export default {"zoomModal":"B2-z","image":"C2-z","button":"D2-z","isOverlayShown":"E2-z"};